import { useUserStore } from '~/store/useUserStore'

export default defineNuxtPlugin((nuxtApp) => {
    const userStore = useUserStore()
    const runtimeConfig = useRuntimeConfig()

    const getApiBaseUrl = () => {
        const host = import.meta.server ? runtimeConfig.apiServerHost : runtimeConfig.public.apiClientHost

        return `${host}/api/`
    }

    const api = $fetch.create({
        baseURL: getApiBaseUrl(),
        retryStatusCodes: [401],
        retry: 1,
        retryDelay: 100,

        onRequest({ options }) {
            if (userStore.accessToken) {
                options.headers.set('Authorization', `Bearer ${userStore.accessToken}`)
            }
        },
        onResponseError: async({ response, options }) => {
            if (response?._data && response._data.statusCode === 401) {
                try {
                    if (!userStore.refreshToken) {
                        userStore.clearData()
                        await nuxtApp.runWithContext(() => navigateTo('/auth'))

                        return
                    }

                    const res = await $fetch<{accessToken: string, refreshToken: string}>('/api/user/refreshToken', {
                        baseURL: getApiBaseUrl(),
                        method: 'POST',
                        headers: {
                            Authorization: `Bearer ${userStore.refreshToken}`,
                        },
                    })

                    userStore.setTokens(res)

                    options.headers.set('Authorization', res.accessToken)
                } catch {
                    userStore.clearData()
                    await nuxtApp.runWithContext(() => navigateTo('/auth'))
                }
            }
        },
        onRequestError: () => {
            if (import.meta.browser) {
                // useToast().add({ title: ctx.error?.message || 'General Message', color: 'error' })
            }
        },
    })

    return {
        provide: {
            api,
        },
    }
})
